/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_route__final_charge = /** @type {(inputs: {}) => string} */ () => {
	return `Ankunft in`
};

const en_route__final_charge = /** @type {(inputs: {}) => string} */ () => {
	return `Arrival at`
};

const es_route__final_charge = /** @type {(inputs: {}) => string} */ () => {
	return `Llegada a`
};

const fr_route__final_charge = /** @type {(inputs: {}) => string} */ () => {
	return `Arrivée à`
};

const it_route__final_charge = /** @type {(inputs: {}) => string} */ () => {
	return `Arrivo a`
};

const nl_route__final_charge = /** @type {(inputs: {}) => string} */ () => {
	return `Aankomst bij`
};

const pt_route__final_charge = /** @type {(inputs: {}) => string} */ () => {
	return `Chegada a`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const route__final_charge = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.route__final_charge(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("route__final_charge", locale)
	if (locale === "de") return de_route__final_charge(inputs)
	if (locale === "en") return en_route__final_charge(inputs)
	if (locale === "es") return es_route__final_charge(inputs)
	if (locale === "fr") return fr_route__final_charge(inputs)
	if (locale === "it") return it_route__final_charge(inputs)
	if (locale === "nl") return nl_route__final_charge(inputs)
	return pt_route__final_charge(inputs)
};